import { useCallback } from 'react';
import type { FlatListProps } from 'react-native';
import { bridge, getNumberRange, isNil } from 'shared/src/utils';
import type { RecommendedMarket } from 'shared/src/api/marketService/getMarketDetail/types';
import {
  retainedStateFamily,
  useRetainedRef,
} from 'shared/src/hooks/retainedState';

const SCREEN_NAME = 'MARKET';
const loggedIndicesFamily = retainedStateFamily<string, number[]>(() => []);

export const useLogDisplayMarket = (params: {
  list_id: string;
  count: number;
}) => {
  // const marketItemLoggedList = useRef<Array<number>>([]);
  const marketItemLoggedList = useRetainedRef(
    loggedIndicesFamily(`MarketHome-${params.list_id}`),
  );
  return useCallback<
    NonNullable<FlatListProps<RecommendedMarket>['onViewableItemsChanged']>
  >(
    ({ viewableItems }) => {
      viewableItems.forEach(({ index, isViewable, item }) => {
        if (isNil(index) || !isViewable) {
          return;
        }
        if (marketItemLoggedList.current.includes(index)) {
          return;
        }
        marketItemLoggedList.current.push(index);

        bridge.logAnalyticsEvent({
          channel: ['amplitude', 'ablylog', 'firebase'],
          name: 'DISPLAY_MARKET',
          analytics: {
            SCREEN: SCREEN_NAME,
            MARKET_NAME: item.name,
            MARKET_SNO: item.sno.toString(),
            FAVORITES_COUNT: item.favorites_count,
            FAVORITES_COUNT_RANGE: getNumberRange({
              rangeUnit: 500,
              target: item.favorites_count,
            }),
            MARKET_TYPE: item.market_type.name,
            AGE_TAG1: item.age_tags[0],
            AGE_TAG2: item.age_tags[1],
            STYLE_TAG1: item.style_tags[0],
            STYLE_TAG2: item.style_tags[1],
            IS_EXIST_USABLE_COUPONS: 0,
            IS_EXIST_DOWNLOADABLE_COUPONS: null,
            IS_TODAY_MARKET: 0,
            LIST_ID: params.list_id,
            RECOMMENDED_MARKETS_COUNT: params.count,
            LIST_INDEX: index,
            INDEX: index,
          },
        });
      });
    },
    [marketItemLoggedList, params.count, params.list_id],
  );
};
